import { render, staticRenderFns } from "./especificaciones-sst-adquisiciones.vue?vue&type=template&id=5da56a82&"
import script from "./especificaciones-sst-adquisiciones.vue?vue&type=script&lang=js&"
export * from "./especificaciones-sst-adquisiciones.vue?vue&type=script&lang=js&"
import style0 from "./especificaciones-sst-adquisiciones.vue?vue&type=style&index=0&id=5da56a82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports